import { dishesSteps } from 'common/constants/menu';

class UIActionsHelper {
  static *dishesSteps() {
    // yield dishesSteps.first;
    yield dishesSteps.second;
    yield dishesSteps.third;
    yield dishesSteps.fourth;
    yield dishesSteps.fifth;
    // yield dishesSteps.sixth;
  }

  static getDeliveryHoursItem = (opening_hours, day) => {
    if (!Array.isArray(opening_hours)) {
      return {};
    }

    return opening_hours.find((i) => i.day_number === day);
  };

  static onClickStripe = () => {};
}

export default UIActionsHelper;
